/**
 *	shops-in-bounds.reducer.js
 */

export default function(state = null, action = {}) {

    switch (action.type) {

        case 'SET_SHOPS_IN_BOUNDS':
			if (action.shopsInBounds) {
				return action.shopsInBounds.map((shop) => {
	                return shop;
	            });
			} else {
				return null;
			}
			break;
        default:
            return state;
    }
}